import { createContext, useState, useEffect, type ReactNode } from 'react';

export interface AuthState {
  token: string | null;
  email: string | null;
}

export interface AuthContextValue {
  state: AuthState;
  login: (token: string, email: string) => void;
  logout: () => void;
}

export const AuthCtx = createContext<AuthContextValue>({
  state: { token: null, email: null },
  login: () => {},
  logout: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({
    token: localStorage.getItem('crm-token'),
    email: localStorage.getItem('crm-email'),
  });

  useEffect(() => {
    if (state.token) localStorage.setItem('crm-token', state.token);
    else localStorage.removeItem('crm-token');
    if (state.email) localStorage.setItem('crm-email', state.email);
    else localStorage.removeItem('crm-email');
  }, [state]);

  const login = (token: string, email: string) => setState({ token, email });
  const logout = () => setState({ token: null, email: null });

  return <AuthCtx.Provider value={{ state, login, logout }}>{children}</AuthCtx.Provider>;
}
